module.exports = __webpack_public_path__ + "static/media/icon_addinbtn.775a05d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_addinbtn.svg
// module id = 749
// module chunks = 0